import { graphql, readInlineData } from "react-relay";

import { checkIsPlusPage } from "scmp-app/components/pages/plus-pages/helpers";
import type { helpersAppBarVariantBase$key } from "scmp-app/queries/__generated__/helpersAppBarVariantBase.graphql";

export type Application = "plus" | "scmp";
export type Theme = "default" | "embed" | "print-article";

export const getApplication = (reference: helpersAppBarVariantBase$key): Application => {
  const content = readInlineData(
    graphql`
      fragment helpersApplicationBase on BaseWithApplicationAndUrlAlias @inline {
        ...helpersCheckIsPlusPage
      }
    `,
    reference,
  );

  if (checkIsPlusPage(content)) return "plus";

  return "scmp";
};
